import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllScheduleThunk = createAsyncThunk(
    'schedule/getAllSchedule',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllScheduleEnq(config);
            //   console.log(response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getScheduleStatisticsThunk = createAsyncThunk(
    'schedule/getScheduleStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getScheduleEnqStatistics(config);
            //   console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const scheduleDetailsThunk = createAsyncThunk(
    'schedule/scheduleDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getScheduleDetails(id);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportScheduleThunk = createAsyncThunk(
    'order/exportScheduleThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllScheduleEnq(config);
            //   console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteScheduleThunk = createAsyncThunk(
    'order/deleteorder',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteScheduleEnq(id);
            dispatch(setschedulerefresh())
            toast.success('schedule enquiry deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete schedule enquiry')
        }
    }
);

export const deleteProductFromScheduleThunk = createAsyncThunk(
    'order/deleteorder',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteProductFromenq(data);
            dispatch(setschedulerefresh())
            toast.success('product deleted from enquiry  successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete product')
        }
    }
);


export const approveEnquiryThunk = createAsyncThunk(
    'order/approveEnquiryThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.approveScheduleEnquiry(data);
            dispatch(setschedulerefresh())
            toast.success('enquiry approved  successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to approve the product')
        }
    }
);

export const updateProductFromScheduleThunk = createAsyncThunk(
    'order/updateProductFromSchedule',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updateProductFromenq(data);
            dispatch(setschedulerefresh())
            toast.success('product updated from enquiry  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to updat product')
        }
    }
);


export const dispatchScheduleorderThunk = createAsyncThunk(
    'order/dispatchScheduleorderThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.dispatchScheduleOrder(data);
            dispatch(setschedulerefresh())
            toast.success('order dispatched successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to updat product')
        }
    }
);


export const confirmDeliveryThunk = createAsyncThunk(
    'order/confirmDeliveryThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.confirmDelivery(data);
            dispatch(setschedulerefresh())
            toast.success('order status updated successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to updat product')
        }
    }
);



export const createScheduleEnquiryThunk = createAsyncThunk(
    'order/createScheduleEnquiryThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.createScheduleenquiry(data);
            dispatch(setschedulerefresh())
            toast.success('order status updated successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to updat product')
        }
    }
);

const scheduleSlice = createSlice({
    name: 'schedule',
    initialState: {
        schedule: [],
        orderDetails: {},
        scheduletatistics: {
            data: {},
            loading: false
        },
        refresh: false,
        loading: false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setschedulerefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setSchedulePage: (state, action) => {
            state.page = action.payload
        },
        setScheduleSearch: (state, action) => {
            state.search = action.payload
        },
        setScheduleStatus: (state, action) => {
            state.status = action.payload
        },
        setScheduleFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setScheduleToDate: (state, action) => {
            state.toDate = action.payload
        },
        setScheduleSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setscheduleData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllScheduleThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllScheduleThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.schedule = action.payload;
            })
            .addCase(getAllScheduleThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(scheduleDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(scheduleDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload;
            })
            .addCase(scheduleDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportScheduleThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportScheduleThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportScheduleThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getScheduleStatisticsThunk.pending, (state) => {
                state.scheduletatistics.loading = true;
            })
            .addCase(getScheduleStatisticsThunk.fulfilled, (state, action) => {
                state.scheduletatistics.loading = false;
                state.scheduletatistics.data = action.payload
            })
            .addCase(getScheduleStatisticsThunk.rejected, (state, action) => {
                state.scheduletatistics.loading = false
            })
    },
});

export const { setschedulerefresh, setSchedulePage, setScheduleSearch, setScheduleStatus, setScheduleFromDate, setScheduleToDate, setScheduleSelectedTab, setscheduleData } = scheduleSlice.actions
export default scheduleSlice.reducer;

